import { Button } from 'atoms/Button';
import { Icon, IconType } from 'atoms/Icon';
import { H2, P, Span } from 'atoms/Typography';
import { useTranslations } from 'modules/i18n/useTranslations';
import { usePathname, useRouter } from 'modules/next/hooks';
import { usePopoverManager } from 'modules/shop/popoverManager/hooks';
import { AppRoutes } from 'modules/shop/routes';
import { useUser } from 'modules/shop/user/hooks';
import styles from './styles.module.css';

export const AccountView = () => {
  const t = useTranslations();
  const router = useRouter();
  const pathname = usePathname();
  const { closePopover } = usePopoverManager();
  const { logout } = useUser();

  const handleLogout = async () => {
    const exclusionRoutes = [
      AppRoutes.ACCOUNT,
      AppRoutes.CHECKOUT,
      AppRoutes.CART,
      AppRoutes.LEAVE_REVIEW,
    ];

    await logout();
    closePopover();

    /* If the route matches exclusionRoutes, redirect to the Login page */
    if (exclusionRoutes.some((route) => pathname.includes(route))) {
      router.push(AppRoutes.LOGIN);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div>
          <H2 className={styles.authTitle}>{t('login.popup.auth-title')}</H2>
          <P className={styles.subtitle}>{t('login.popup.auth-subtitle')}</P>
        </div>
        <Button onClick={() => router.push(AppRoutes.ACCOUNT)}>
          {t('login.popup.auth-button')}
        </Button>
      </div>
      <div className={styles.bottom}>
        <Span onClick={handleLogout} className={styles.logout}>
          <Icon type={IconType.arrowRight} className={styles.logoutIcon} />
          {t('common.buttons.exit')}
        </Span>
      </div>
    </div>
  );
};
